/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-15 16:18:32
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-25 13:45:04
 */

export default {
  path: '/',
  component: () => import(/* webpackChunkName: "customer-list" */ '@/pages/home/Home'),
  meta: {title:'首页'},
}